module.exports = __webpack_public_path__ + "static/media/hashtag.43a8205b.svg";